import { createFileRoute } from "@tanstack/react-router";
import EventCheckinPage from "@/pages/EventCheckinPage";

export const Route = createFileRoute("/event-checkin/$coachId")({
  component: EventCheckinPage,
});
